<template>
    <div class="meIndexWrap">
        <!-- <nav-bar></nav-bar> -->
        <div>
            <div class="top">
                <div class="user fr ac">
                    <!-- <img v-if="isLogin && memberInfo.headimgurl" :src="formatAvatar" alt class="avatar" /> -->
                    <img src="../../../static/imgs/movie/avatar.png" alt class="defaultAvatar" />
                    <button @click="logIn" v-show="!isLogin" class="login">登录</button>
                    <span v-show="isLogin" class="nickname">{{memberInfo.mobile ? memberInfo.mobile : ""}}</span>
                </div>
            </div>
            <div class="topBar fr ac jsa">
                <div @click="goOrderList('paid')" class="barItem fc ac jc">
                    <img src="../../../static/imgs/movie/allOrders.png" alt />
                    <span>全部订单</span>
                </div>
                <!-- <div @click="viewCoupons" class="barItem fc ac jc">
                    <img src="../../../static/imgs/movie/coupons.png" alt />
                    <span>优惠券</span>
                </div>-->
                <div v-show="!isKfc" @click="setPayPwd" class="barItem fc ac jc">
                    <img src="../../../static/imgs/movie/pwd.png" alt />
                    <span>支付密码</span>
                </div>
                <div @click="contact" class="barItem fc ac jc">
                    <img src="../../../static/imgs/movie/service.png" alt />
                    <span>客服服务</span>
                </div>
            </div>
            <button v-show="isLogin" @click="logOut" class="logOut">退出登录</button>
            <!-- <div class="myOrders fc">
                <h3>我的订单</h3>
                <div class="orderTypes fr ac">
                    <div class="typeBox">
                        <div @click="goOrderList('pending')" class="fr ac jc">
                            <img src="../../../static/imgs/movie/orderstatus_doing.png" alt />
                            <span>未支付</span>
                        </div>
                        <span v-show="memberInfo.unpaid" class="redDot"></span>
                    </div>
                    <div class="typeBox">
                        <div @click="goOrderList('paid')" class="fr ac jc">
                            <img src="../../../static/imgs/movie/orderstatus_done.png" alt />
                            <span>已支付</span>
                        </div>
                    </div>
                </div>
            </div>-->

            <!-- <div @click="bindVipCard" class="row fr ac jsb">
                <span>贵宾卡</span>
                <img class="rightIco" src="../../../static/imgs/movie/rightArrow.png" alt />
            </div>
            <div @click="setPayPwd" class="row fr ac jsb">
                <span>支付密码设置</span>
                <img class="rightIco" src="../../../static/imgs/movie/rightArrow.png" alt />
            </div>-->
            <tab-bar v-show="!isKfc"></tab-bar>
            <kfc-tab-bar v-show="isKfc"></kfc-tab-bar>
        </div>
    </div>
</template>

<script>
import tabBar from "../../components/common/tabBar.vue";
import kfcTabBar from "../../components/common/kfcTabBar.vue";
import navBar from "../../components/common/navBar.vue";
import { Toast, MessageBox } from "mint-ui";
export default {
    data() {
        return {
            memberInfo: {},
            isLogin: this.getLocal("hasLogged") ? true : false,
            avatarPath: "",
            isKfc: this.$route.query.isKfc ? this.$route.query.isKfc : "",
            domainType: this.$global.domainType
        };
    },
    components: {
        tabBar,
        navBar,
        kfcTabBar
    },
    computed: {
        formatAvatar: function() {
            if (this.avatarPath && this.avatarPath.indexOf("http") != 0) {
                return "http://res.dumovie.com/" + this.avatarPath;
            } else if (this.avatarPath) {
                return this.avatarPath;
            }
        }
    },
    created() {
        this.getMemberInfo().then(res => {
            if (res.success) {
                this.memberInfo = res.data.member;
                this.avatarPath = res.data.member.headimgurl;
                this.isLogin = true;
            }
        });
    },
    methods: {
        goOrderList(type) {
            // this.$router.push({
            //     path: "/orderList",
            //     query: { orderStatus: type }
            // });
            if (this.isLogin) {
                let auth_code = this.getLocal("auth_code")
                // window.location.href = "https://wx.dumovie.com/app/order/movie/list?auth_code=" + auth_code  + '&app_source=h5';
                window.location.href = "https://wx."+ this.domainType +"/app/order/movie/list?auth_code=" + auth_code  + '&app_source=h5';
            } else {
                Toast({
                    message: "请先登录！",
                    position: "middle",
                    duration: 2000,
                    className: "toastBox"
                });
                this.$router.push("/logup")
            }
        },
        bindVipCard() {
            this.$router.push({ path: "/myVipCard" });
        },
        // 去设置支付密码
        setPayPwd() {
            this.$router.push({ path: "/setPayPwd" });
        },
        viewCoupons() {
            this.$router.push("/couponList");
        },
        logIn() {
            this.$router.replace({path: "/logup", query: {isKfc: this.isKfc}});
        },
        logOut() {
            MessageBox.confirm("确定退出此账号?")
                .then(action => {
                    if (action == "confirm") {
                        this.confirmLogOut();
                    }
                })
                .catch(err => {});
        },
        confirmLogOut() {
            this.isLogin = false;
            this.removeLocal("auth_code");
            this.removeLocal("phoneNo");
            this.removeLocal("hasLogged");
            this.removeLocal("openid");
            this.removeLocal("cartArr");
            this.removeLocal("selectedAddress");
            Toast({
                message: "退出成功！",
                position: "middle",
                duration: 2000,
                className: "toastBox"
            });
        },
        contact() {
            let serviceNo  = this.getLocal("serviceNo")
            console.log(serviceNo)
            window.location.href = "tel://" + serviceNo;
        }
    }
};
</script>
<style lang="scss">
.meIndexWrap {
    .top {
        width: 100%;
        height: 276px;
        background-image: url(../../../static/imgs/movie/top_bg.png);
        background-size: cover;
        background-position: center;
        color: #fff;
        .user {
            width: 100%;
            height: 180px;
            padding: 0 38px;
            box-sizing: border-box;
            .defaultAvatar {
                width: 120px;
                height: 120px;
            }
            .avatar {
                width: 110px;
                height: 110px;
                border: 5px solid #fff;
                border-radius: 50%;
            }
            .login {
                width: 160px;
                height: 60px;
                font-size: 26px;
                margin-left: 35px;
                background: rgba($color: #fff, $alpha: 0.4);
                color: #fff;
                border-radius: 30px;
            }
            .nickname {
                font-size: 36px;
                margin-left: 35px;
                color: #fff;
            }
        }
    }
    .topBar {
        width: calc(100% - 76px);
        margin: 0 38px;
        background: #fff;
        border-radius: 15px;
        // padding: 0 75px;
        padding: 0 35px;
        box-sizing: border-box;
        margin-top: -100px;
        .barItem {
            height: 275px;
            img {
                width: 87px;
                height: 87px;
                margin-bottom: 28px;
            }
            span {
                font-size: 24px;
            }
        }
    }
    .logOut {
        width: 630px;
        height: 98px;
        border-radius: 49px;
        background: #c9c9c9;
        color: #fff;
        margin: 120px 60px 0 60px;
        font-size: 32px;
    }
    .myOrders {
        background-color: #fff;
        font-size: 32px;
        h3 {
            width: 100%;
            height: 90px;
            line-height: 90px;
            padding: 0 40px;
            box-sizing: border-box;
            border-bottom: 1px solid #ddd;
        }
        .orderTypes {
            width: 100%;
            height: 128px;
            padding: 0 40px;
            div {
                flex-basis: 50%;
                img {
                    width: 52px;
                    height: 52px;
                }
                span {
                    margin-left: 30px;
                }
            }
            div:first-of-type {
                border-right: 1px solid #ddd;
            }
            .typeBox {
                position: relative;
                .redDot {
                    width: 16px;
                    height: 16px;
                    border-radius: 50%;
                    background-color: #ec5f2a;
                    position: absolute;
                    top: 0;
                    right: 45px;
                }
            }
        }
    }
    .row {
        width: 100%;
        height: 100px;
        padding: 0 30px;
        box-sizing: border-box;
        background-color: #fff;
        font-size: 32px;
        margin-top: 20px;
        .rightIco {
            width: 40px;
            height: 40px;
        }
    }
    .contact {
        width: 620px;
        height: 90px;
        background: #fff;
        font-size: 32px;
        border-radius: 10px;
        margin: 50px calc(50% - 310px);
    }
}
.mint-msgbox {
    font-size: 28px !important;
    border-radius: 10px;
    .mint-msgbox-header {
        padding-top: 30px;
        .mint-msgbox-title {
            font-size: 30px !important;
        }
    }
    .mint-msgbox-content {
        padding: 30px;
    }
    .mint-msgbox-btns {
        height: 70px;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/me/meIndex.vue